import styled, { css } from 'styled-components'
import { HeadingProps, HeadingStyles } from '@chegg-wt/core/theme/sharedStyled'
import { AspiraStack } from '@chegg-wt/core/theme/fanta/fonts'
import { LayoutAlignProps } from '@chegg-wt/core/types/layout'

export const Container = styled.div.attrs({
  role: 'region',
  'aria-label': 'CMS Content',
})`
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor20};
`

export const CMSContentBox = styled.div`
  ${AspiraStack};
  color: ${({ theme }) => theme.colors.greyDark};
  border: ${({ theme }) => `1px solid ${theme.colors.greyDDD}`};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 6px;
  font-size: ${({ theme }) => theme.font.text.size.lg};
  margin: 5px 0px;
`

export const ContentContainer = styled.div`
  margin: ${({ theme }) => theme.spacing.md};
`

export const ContentHeader = styled.h3<HeadingProps>`
  ${HeadingStyles};
  && {
    font-size: 20px;
  }
`

export const Header = styled(CMSContentBox)`
  width: 20%;
  margin-right: 4px;
`

export const Body = styled(CMSContentBox)`
  width: 80%;
`
export const P = styled.p`
  font-size: 14px;
`

// To center align Review page content(question-answer) for low-ad-test optimizely experiment.
export const Wrapper = styled.div<LayoutAlignProps>`
  ${(props) =>
    props.layoutHRCenter &&
    css`
      max-width: 880px;
      margin: auto;
    `}
`

export default CMSContentBox
